import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Button,
  Input,
  Badge,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  InputGroup,
  Spinner,
  CardTitle,
  CardText,
  CardImg,
} from "reactstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import { Link, useNavigate } from "react-router-dom";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";
import { imageBaseApi } from "../../../utilis/imageHelper";
import TestService from "../../../services/KangarooServices/TestService";

const TestPreparation = () => {
  const [blogs, setBlogs] = useState([]);
  const [meta, setMeta] = useState({ total: 0, page: 1, pageSize: 10 });

  const [filters, setFilters] = useState({
    // search: "",
    // status: "",
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);

  // Delete modal states
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);
  const navigate = useNavigate();

  // -----------------------------
  // Fetch TestPreparation (server-side)
  // -----------------------------
  const fetchBlog = async (
    page = currentPage,
    size = pageSize
    // currentFilters = debouncedFilters
  ) => {
    setLoading(true);
    try {
      const response = await TestService.getList({
        // ...currentFilters,
        page,
        pageSize: size,
      });

      setBlogs(response.items || []);
      setMeta({
        total: response.total || 0,
        page: response.page || page,
        pageSize: size,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // initial load
  useEffect(() => {
    fetchBlog();
  }, []);

  // debounce filters
  // useEffect(() => {
  //   const t = setTimeout(() => {
  //     setDebouncedFilters(filters);
  //     setCurrentPage(1);
  //   }, 500);

  //   return () => clearTimeout(t);
  // }, [filters]);

  // refetch on debounced filter update
  useEffect(() => {
    fetchBlog(1);
  }, []);

  // handle search + status change
  const handleSearchChange = (e) =>
    setFilters((prev) => ({ ...prev, search: e.target.value }));

  const handleStatusChange = (e) =>
    setFilters((prev) => ({ ...prev, status: e.target.value }));

  // delete
  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await TestService.delete(selectedDeleteItem);
        fetchBlog();
        toast.success("TestPreparation deleted successfully");
      } catch (error) {
        toast.error("Delete failed");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  // normalize blog status
  const normalizeStatus = (status) => {
    const s = String(status).toLowerCase();
    if (s === "0" || s === "draft") return "draft";
    if (s === "1" || s === "published") return "published";
    if (s === "2" || s === "archived") return "archived";
    return "draft";
  };

  const statusMap = {
    draft: { label: "Draft", color: "secondary" },
    published: { label: "Published", color: "success" },
    archived: { label: "Archived", color: "dark" },
  };

  // pagination click
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchBlog(page);
  };

  const totalPages = Math.ceil(meta.total / meta.pageSize);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Test Preparation" pageTitle="Content Management" />

        {/* Filters */}
        <Row className="mb-4">
          <Col>
            <div className="d-flex justify-content-between align-items-center ">
              <button
                className="btn btn-success"
                onClick={() => navigate("/test-preparation/create")}
              >
                <i className="bi bi-plus-lg"></i> New Test
              </button>
            </div>
          </Col>
          <Col
            className="d-flex justify-content-end align-items-end mb-2"
            md={6}
          >
            <InputGroup className="w-auto">
              <Input
                placeholder="Search..."
                value={filters.search}
                onChange={handleSearchChange}
              />
            </InputGroup>
          </Col>

          
        </Row>

        {/* TestPreparation List */}
        <Row xs="1" md="2" lg="3" className="g-4">
          {blogs.map((blog) => {
            const statusKey = normalizeStatus(blog.status);
            const { isActive, color } = statusMap[statusKey];

            return (
              <Col key={blog.id}>
                <Card className="h-100 shadow-sm border-0 rounded-4">
                  <div
                    className="position-relative"
                    style={{ aspectRatio: "16/9", overflow: "hidden" }}
                  >
                    <CardImg
                      src={`${imageBaseApi}${blog?.media?.url}`}
                      className="card-img-top w-100 h-100"
                      alt={blog.title}
                      loading="lazy"
                      style={{ objectFit: "contain" }}
                    />
                    <Badge
                      color={color}
                      className="position-absolute top-0 end-0 m-2 px-3 py-2 rounded-pill shadow-sm"
                    >
                      {isActive}
                    </Badge>
                  </div>

                  <CardBody className="d-flex flex-column">
                    <small className="text-muted mb-2">
                      {blog?.testHeading}
                    </small>
                    <CardTitle
                      tag="h5"
                      className="fw-bold text-dark mb-2 two-line-title"
                    >
                      {blog.preparationName}
                    </CardTitle>

                    <div
                      className="content-preview small mb-2"
                      style={{ overflow: "hidden", lineHeight: "1.4" }}
                      dangerouslySetInnerHTML={{
                        __html:
                          blog.description?.length > 300
                            ? blog.description.slice(0, 300) + "..."
                            : blog.description,
                      }}
                    />

                    <div className="d-flex justify-content-between text-muted small mb-2">
                      {/* <span>⏱ {blog.readingTime || 1} min read</span> */}

                      {/* <div className="">
                        <Badge
                          pill
                          color="light"
                          className="me-1 text-dark border"
                        >
                          {blog.category || "General"}
                        </Badge>
                        {blog.tags?.slice(0, 2).map((tag) => (
                          <Badge key={tag} pill color="dark" className="me-1">
                            {tag}
                          </Badge>
                        ))}
                        {blog.tags?.length > 2 && (
                          <Badge pill color="dark">
                            +{blog.tags.length - 2}
                          </Badge>
                        )}
                      </div> */}
                      <span>
                        {blog.createdAt
                          ? new Date(blog.createdAt).toLocaleDateString()
                          : "Not Published"}
                      </span>
                    </div>

                    {/* <small className="text-muted mb-2">
                      by {blog.author || "Admin"}
                    </small> */}

                    <div className="d-flex justify-content-between align-items-center mt-auto">
                      <Link
                        to={`/test-preparation/${blog.id}`}
                        className="card-link link-secondary text-decoration-none fw-semibold d-flex align-items-center"
                      >
                        View Details
                        <i className="ri-arrow-right-s-line ms-1 align-middle lh-1"></i>
                      </Link>
                      <div>
                        <Button
                          size="sm"
                          color="primary"
                          className="me-2 rounded-pill"
                          onClick={() => navigate(`/test-preparation/update/${blog.id}`)}
                        >
                          <i className="bx bx-edit-alt"></i>
                        </Button>

                        <Button
                          size="sm"
                          color="danger"
                          className="rounded-pill"
                          onClick={() => handleDeleteClick(blog.id)}
                        >
                          <i className="ri-delete-bin-5-line"></i>
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>

        {/* No results */}
        {blogs.length === 0 && (
          <Card className="text-center p-5 my-5">
            <CardBody>
              <h4>No Test Preparation found</h4>
              <p className="text-muted">Try adjusting filters or search.</p>
            </CardBody>
          </Card>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <ul className="pagination pagination-lg">
              {[...Array(totalPages)].map((_, i) => {
                const page = i + 1;
                return (
                  <li
                    key={page}
                    className={`page-item ${
                      page === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </Container>

      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </div>
  );
};

export default TestPreparation;
